import * as ImgCache from 'imgcache.js'
import * as sentry from '../../src/utils/sentry'
import { Imag_startUploadingPhotos } from './Imag.Photo'

export async function Imag_initialise() {
    try {
        if (!ENV.isProduction) {
            ImgCache.options.debug = true
        }

        ImgCache.options.withCredentials = true

        await new Promise<void>((resolve, reject) => ImgCache.init(resolve, reject))

        await Imag_startUploadingPhotos()
    } catch (error) {
        sentry.err(error, {})
    }
}
